export default "https://cdn-static.gokick.com/assets/0f3104c02f0c7e58561d070a1e1ba5e916429e4c/images/tangerine-flavor.f6541269ddee78b301b9a4e8b180b6f6.png";